import React from 'react';
import {
    MenuItem,
    TextField,
    Grid,
    Chip,
  } from "@mui/material";

function GridGama({handler}, {edificio}) {
  return (
    <div>
        <Grid item xs={3}>
            <TextField
              label="Edifício"
              variant="outlined"
              value={edificio}
              style={{ minWidth: 130, maxWidth: 150 }}
              select
              onChange={handler}
              SelectProps={{
                multiple: false,
                renderValue: (selected) => (
                  <div style={{ display: "flex", flexWrap: "wrap" }}>
                      <Chip key={selected} label={selected} style={{ margin: 2 }} />
                  </div>
                ),
              }}
            >
                
                <MenuItem value={'FGA LDTEA'}>FGA LDTEA</MenuItem>
<MenuItem value={'FGA MESP'}>FGA MESP</MenuItem>
<MenuItem value={'FGA SUBST'}>FGA SUBST</MenuItem>
<MenuItem value={'FGA UEA'}>FGA UEA</MenuItem>
<MenuItem value={'FGA UED'}>FGA UED</MenuItem>

            </TextField>
          </Grid>

    </div>
  )
}

export default GridGama